import { useSelector } from 'react-redux';
import SpotifyWebApi from 'spotify-web-api-node';
import { useDispatch } from 'react-redux';
import { setNewInidanRelease } from 'actions/action';
import AppInstance from 'utils/instance';

const useNewIndianRelease = () => {
  const dispatch = useDispatch();
  const webApi = new SpotifyWebApi();

  const token = AppInstance.getAccessToken();

  webApi.setAccessToken(token.access_token);

  const getNewIndianRelease = async () => {
    dispatch(
      setNewInidanRelease({
        isLoading: true,
        isError: false,
        data: null,
      })
    );
    try {
      const data = await webApi.getNewReleases({ limit: 10, country: 'IN' });
      dispatch(
        setNewInidanRelease({
          isLoading: false,
          isError: false,
          data: data.body,
        })
      );
    } catch (error) {
      AppInstance.removeAccessToken();
      dispatch(
        setNewInidanRelease({
          isLoading: false,
          isError: true,
          data: null,
        })
      );
    }
  };

  return { getNewIndianRelease };
};

export default useNewIndianRelease;
